<template>
  <section class="section section-shaped section-lg my-0">
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div class="text-muted text-center mb-12">
                <h5>Activación</h5>
              </div>
              <div class="text-center" v-if="loading">
                <img style="max-height: 70px;" v-bind:src="'./img/custom/loading.svg'" />Loading...
              </div>
            </template>
            <template>
              <form id="registro" @submit.prevent="validateForm">
                <div class="row">
                  <div class="col-12" v-if="errors.length">
                    <div>
                      <base-alert type="default">
                        <span class="alert-inner--icon">
                          <i class="ni ni-bell-55"></i>
                        </span>
                        <span class="alert-inner--text">
                          <ul style="margin: 0px;">
                            <li v-for="error of errors" v-bind:key="error">{{ error }}</li>
                          </ul>
                        </span>
                      </base-alert>
                    </div>
                  </div>

                  <div class="col-12"></div>

                  <div class="col-12" role="form">
                    <base-input
                      alternative
                      class="mb-3"
                      placeholder="Ingresa el código Civ de la tarjeta."
                      v-model="user.card_code"
                      v-on:keyup.enter="verifyCard"
                      :disabled="genuine_civ_code"
                      required
                    ></base-input>
                    <div class="text-center" v-if="!genuine_civ_code">
                      <base-button
                        type="primary"
                        class="my-4"
                        v-on:click="verifyCard"
                        :disabled="loading"
                      >Verificar Tarjeta</base-button>
                    </div>
                  </div>
                  <div class="col-12" role="form" v-if="genuine_civ_code">
                    <base-input
                      alternative
                      class="mb-3"
                      placeholder="Documento de identificación"
                      v-model="user.identification_number"
                      :disabled="verified_identification"
                      v-on:keyup.enter="verifyIdentification"
                    ></base-input>
                    <div class="text-center" v-if="!verified_identification">
                      <base-button
                        type="primary"
                        class="my-4"
                        v-on:click="verifyIdentification"
                        :disabled="loading"
                      >Verificar documento</base-button>
                    </div>
                  </div>
                  <div class="col-12" role="form" v-if="!code_verified">
                    <base-input
                      alternative
                      class="mb-3"
                      placeholder="Código de verificación"
                      v-model="verification_key"
                      :disabled="code_verified"
                      v-on:keyup.enter="verifyCode"
                    ></base-input>

                    <div
                      class="text-center"
                      v-if="!code_verified"
                      v-on:click="verifyIdentification"
                      style="cursor: pointer"
                    >Reenviar código</div>

                    <div class="text-center" v-if="!code_verified">
                      <base-button
                        type="primary"
                        class="my-4"
                        v-on:click="verifyCode"
                        :disabled="loading"                        
                      >Validar Código</base-button>
                    </div>
                  </div>
                  <div
                    class="col-12"
                    role="form"
                    v-if="genuine_civ_code && verified_identification && code_verified"
                  >
                    <div class="row">
                      <div class="col-lg-6 col-ls-12">
                        <base-input
                          alternative
                          class="mb-3"
                          placeholder="Nombres"
                          v-model="user.first_name"
                        ></base-input>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <base-input
                          alternative
                          class="mb-3"
                          placeholder="Apellidos"
                          v-model="user.last_name"
                        ></base-input>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <select class="form-control" v-model="user.identification_type">
                            <option value="" selected disabled>Tipo de identificación</option>
                            <option v-for="identification_type in identification_types" v-bind:key="identification_type">{{identification_type}}</option>
                        </select>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <base-input
                          alternative
                          class="mb-3"
                          placeholder="Fecha de nacimiento (AAAA-MM-DD)"
                          v-model="user.birth_date"
                        ></base-input>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <base-input
                          alternative
                          class="mb-3"
                          type="email"
                          placeholder="Correo electrónico"
                          v-model="user.email"
                        ></base-input>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <select class="form-control" v-model="user.gender">
                            <option value="" selected disabled>Género</option>
                            <option>Masculino</option>
                            <option>Femenino</option>
                            <option>Otro</option>
                        </select>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <div class="form-group">
                          <select class="form-control" v-model="user.sector">
                            <option value="" selected disabled>Comuna</option>
                            <option
                              v-for="sector in sectors"
                              v-bind:key="sector.id"
                              :value="sector"
                            >{{sector.name}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <base-input
                          alternative
                          class="mb-3"
                          placeholder="Teléfono"
                          v-model="user.phone"
                        ></base-input>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <base-input
                          alternative
                          class="mb-3"
                          type="password"
                          placeholder="Contraseña"
                          v-model="user.password"
                        ></base-input>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <base-input
                          alternative
                          type="password"
                          placeholder="Confirmar contraseña"
                          v-model="user.confirm_password"
                        ></base-input>
                      </div>
                    </div>
                    <div>
                      <base-checkbox class="mb-3" v-model="user.terms_and_conditions">
                        <a
                          href="#"
                          class="btn btn-link text-info"
                          @click="modals.modal0 = true"
                          style="padding: 0px !important; color: inherit !important"
                        >Términos y condiciones</a>
                      </base-checkbox>
                      <modal :show.sync="modals.modal0">
                        <h6
                          slot="header"
                          class="modal-title"
                          id="modal-title-default"
                        >Terminos y condiciones</h6>Declaro que he leído, entiendo y acepto la información contenida en la
                        <a
                          href="https://www.medellinjoven.com/declaracion-de-derechos-y-responsabilidades"
                          target="_blank"
                        >Declaración de derechos y responsabilidades</a>, la
                        <a
                          href="https://www.medellinjoven.com/politica-de-datos"
                          target="_blank"
                        >Política de datos</a>, la
                        <a
                          href="https://www.medellinjoven.com/politica-de-cookies"
                          target="_blank"
                        >Política de Cookies</a> y la
                        <a
                          href="https://www.medellin.gov.co/normograma/docs/d_alcamed_1096_2018.htm"
                          target="_blank"
                        >Política de tratamiento de datos personales del Municipio de Medellín</a>, que he sido informado de los derechos que me asisten como titular de los datos y los canales habilitados por el Municipio para ejércelos. Que los datos que les he suministrado serán tratados con la finalidad de desarrollar las actividades propias del objeto social para efectos de beneficios y demás tratamientos en la
                        <a
                          href="https://www.medellin.gov.co/normograma/docs/d_alcamed_1096_2018.htm"
                          target="_blank"
                        >Política de tratamiento de datos personales del municipio de Medellín</a>
                        , en consecuencia autorizo plenamente al Municipio de Medellín - Secretaría de la Juventud para que trate los datos personales por mi suministrados conforme lo allí establecido.
                        <template
                          slot="footer"
                        >
                          <base-button
                            type="link"
                            class="ml-auto"
                            @click="modals.modal0 = false"
                          >Cerrar</base-button>
                        </template>
                      </modal>
                    </div>
                    <div class="text-center">
                      <base-button 
                      nativeType="submit" 
                      type="primary" 
                      class="my-4"
                      :disabled="loading"
                      >Registrarse</base-button>
                    </div>
                  </div>
                </div>
              </form>
            </template>
            <template>
              
            </template>
          </card>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
const AmazonCognitoIdentity = require("amazon-cognito-identity-js");
const axios = require("axios");
const moment = require("moment");

import Modal from "@/components/Modal.vue";


export default {
  data() {
    return {
      modals: {
        modal0: false
      },
      title: "Holi",
      errors: [],
      genuine_civ_code: false,
      verified_identification: false,
      code_verified: true,
      verification_key: "",
      loading: false,
      sectors: [
        {
          id: 1,
          name: "Comuna 1 - Popular"
        },
        {
          id: 2,
          name: "Comuna 2 - Santa Cruz"
        },
        {
          id: 3,
          name: "Comuna 3 - Manrique"
        },
        {
          id: 4,
          name: "Comuna 4 - Aranjuez"
        },
        {
          id: 5,
          name: "Comuna 5 - Castilla"
        },
        {
          id: 6,
          name: "Comuna 6 - Doce de Octubre"
        },
        {
          id: 7,
          name: "Comuna 7 - Robledo"
        },
        {
          id: 8,
          name: "Comuna 8 - Villa Hermosa"
        },
        {
          id: 9,
          name: "Comuna 9 - Buenos Aires"
        },
        {
          id: 10,
          name: "Comuna 10 - La Candelaria"
        },
        {
          id: 11,
          name: "Comuna 11 - Laureles Estadio"
        },
        {
          id: 12,
          name: "Comuna 12 - La América"
        },
        {
          id: 13,
          name: "Comuna 13 - San Javier"
        },
        {
          id: 14,
          name: "Comuna 14 - El Poblado"
        },
        {
          id: 15,
          name: "Comuna 15 - Guayabal"
        },
        {
          id: 16,
          name: "Comuna 16 - Belén"
        },
        {
          id: 50,
          name: "Comuna 50 - Corregimiento de San Sebastián de Palmitas"
        },
        {
          id: 60,
          name: "Comuna 60 - Corregimiento de San Cristóbal"
        },
        {
          id: 70,
          name: "Comuna 70 - Corregimiento de Altavista"
        },
        {
          id: 80,
          name: "Comuna 80 - Corregimiento de San Antonio de Prado"
        },
        {
          id: 90,
          name: "Comuna 90 - Corregimiento de Santa Elena"
        },
        {
          id: 100,
          name: "Otro municipio"
        }
      ],
      identification_types: [
        "Cédula",
        "Pasaporte",
        "Registro de Nacimiento",
        "Tarjeta de Identidad"
      ],
      user: {
        card_code: "",
        first_name: "",
        last_name: "",
        identification_type: "",
        identification_number: "",
        birth_date: "",
        email: "",
        gender: "",
        sector: "",
        phone: "",
        password: "",
        confirm_password: "",
        terms_and_conditions: false
      }
    };
  },
  components: {
    Modal
  },
  methods: {
    async verifyCard() {
      this.errors = [];
      this.loading = true;
      this.genuine_civ_code = false;
      var query = {
        card_code: this.user.card_code
      };

      try {
        var response = await axios.get(
          "https://hgogjz2lrh.execute-api.us-west-2.amazonaws.com/api/civ-card",
          {
            params: query
          }
        );

        if (response.status == 200) {
          switch (response.data) {
            case "card_doesnt_exist":
              this.errors.push("El código de tarjeta ingresado, no es válido");
              break;
            case "card_used":
              this.errors.push(
                "El código de tarjeta ingresado, ya se encuentra registrado"
              );
              break;
            case "card_available":
              this.genuine_civ_code = true;
              break;
          }
        } else {
          this.errors.push("Ocurrió un error en la consulta");
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    async verifyIdentification() {
      this.loading = true;
      this.errors = [];

      var query = {
        identification_number: this.user.identification_number
      };

      try {
        var response = await axios.get(
          "https://hgogjz2lrh.execute-api.us-west-2.amazonaws.com/api/users/verify-identification",
          {
            params: query
          }
        );

        if (response.status == 200) {
          switch (response.data) {
            case "invalid_identification":
              this.verified_identification = true;
              break;
            case "error_updating_code":
              this.errors.push(
                "Ocurrió un error intentando generar el codigo de verificación."
              );
              break;
            case "error_sending_code":
              this.errors.push(
                "Ocurrió un error intentando enviar el código de verificación a su correo electrónico."
              );
              break;
            case "done":
              this.errors.push(
                "Hemos enviado un correo electrónico con un código de verificación."
              );
              this.verified_identification = true;
              this.code_verified = false;
              break;
          }
          this.loading = false;
        } else {
          this.errors.push(
            "Ocurrió un error al intentar verificar su número de documento, por favor intentelo de nuevo más tarde"
          );
          this.loading = false;
        }
      } catch (err) {
        console.log(err);
        this.errors.push(
          "Ocurrió un error al intentar verificar su número de documento, por favor intentelo de nuevo más tarde"
        );
        this.loading = false;
      }
    },
    async verifyCode() {
      this.loading = true;
      this.errors = [];
      var query = {
        identification_number: this.user.identification_number,
        verification_key: this.verification_key
      };

      try {
        var response = await axios.get(
          "https://hgogjz2lrh.execute-api.us-west-2.amazonaws.com/api/users/verify-authenticity-code",
          {
            params: query
          }
        );

        if (typeof response.data === "object") {
          let u = response.data;
          this.user.first_name = u.first_name;
          this.user.last_name = u.last_name;
          this.user.identification_type = u.identification_type;
          this.user.birth_date = u.birth_date;
          this.user.email = u.email;
          this.user.gender = u.gender;
          this.user.sector = u.sector;
          this.user.phone = u.phone;

          this.code_verified = true;
        } else {
          switch (response.data) {
            case "invalid_code":
              this.errors.push("El código indicado no es válido");
              break;
            case "invalid_document":
              this.errors.push("El documento indicado no es válido");
              break;
            default:
              this.errors.push(
                "Ocurrió un error al intentar validar el código de verificación"
              );
              break;
          }
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
      }
    },
    async validateForm(){
      this.errors = [];

      if(!this.genuine_civ_code){
        return false;
      }
      // Required
      if(!this.user.card_code)
        this.errors.push("El número de la tarjeta Civ es obligatorio");
      if(!this.user.identification_number)
        this.errors.push("El número de identificación es obligatorio");
      if(!this.user.first_name)
        this.errors.push("El nombre es obligatorio");
      if(!this.user.last_name)
        this.errors.push("El apellido es obligatorio");
      if(!this.user.identification_type)
        this.errors.push("El tipo de identificación es obligatorio");
      if(!this.user.birth_date)
        this.errors.push("La fecha de nacimiento es obligatoria");
      if(!this.user.email)
        this.errors.push("El correo electrónico obligatorio");
      if(!this.user.gender)
        this.errors.push("El género es obligatorio");
      if(!this.user.sector)
        this.errors.push("La comuna es obligatoria");
      if(!this.user.password)
        this.errors.push("La contraseña es obligatoria");
      if(!this.user.confirm_password)
        this.errors.push("Debe confirmar su contraseña");

      if(this.user.password != this.user.confirm_password)
        this.errors.push("Las contraseñas no coinciden");

      if(!this.user.terms_and_conditions)
        this.errors.push("Debe aceptar los términos y condiciones");     
        
      if(this.errors.length){
        return false;
      }

      if(this.user.password.length <6 )
        this.errors.push("La contraseña no es lo suficientemente larga");

      if(!/^[0-9]{7}$/.test(this.user.card_code))
        this.errors.push("El código Civ es incorrecto");

      if(!/^[0-9a-zA-Z\-_]{1,16}$/.test(this.user.identification_number))
        this.errors.push("El número de identificación es incorrecto");

      if(!/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(this.user.email))
        this.errors.push("El correo electrónico es incorrecto");

      if(!/^(19|20){1}[0-9]{2}\-[0-9]{2}\-[0-3]{1}[0-9]{1}$/.test(this.user.birth_date) || isNaN(Date.parse(this.user.birth_date))){
        this.errors.push("La fecha de nacimiento es incorrecta, el formato es AAAA-MM-DD");
      }else{
        if(moment().diff(this.user.birth_date, 'years')>28){
          alert("Hola, con esta tarjeta los jóvenes entre los 14 y 28 años de edad, podrán disfrutar de muchos beneficios y descuentos. Lastimosamente, te encuentras fuera de este rango de edad y en los establecimientos de nuestras marcas aliadas debes presentar tu documento de identidad por lo cual no podrás disfrutar de estos descuentos. Te invitamos a que le regales esta tarjeta a alguien cercano que esté dentro del rango de edades. ¡Gracias!");
          this.user.birth_date = "";
        }
      }

      if (this.errors.length) {
        return false;
      } else {
        return this.signUp();
      }
    },
    async signUp() {
      this.loading = true;
      var user = this.user;
      
      try {
        var response = await axios.put(
          "https://hgogjz2lrh.execute-api.us-west-2.amazonaws.com/api/users/inscription",
          user
        );

        switch (response.data) {
          case "done":
            alert("Has sido registrado exitosamente. En 8 días hábiles podrás empezar a disfrutar de todos los beneficios y descuentos. Pronto podrás iniciar sesión y obtener más información sobre tu cuenta.");
            this.$router.push('/beneficios');
            break;
          case "InvalidParameterException":
            this.errors.push("Existe un error en uno de los campos del formulario, por favor, verifique e inténtelo nuevamente.");
            break;
          case "InvalidPasswordException":
            this.errors.push("La contraseña debe tener al menos 8 caracteres e incluir letras minúsculas y números");
            break;
          case "error_cognito":
            this.errors.push("Tuvimos un fallo al intentar crear su usuario en el sistema");
            break;
          case "error_saving_data":
            this.errors.push("Tuvimos un fallo actualizar su información");
            break;


          case "error_card_mas_vivos":
            this.errors.push("Ocurrió un error intentando registrar la tarjeta");
            break;
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    }
  },
  mounted() {

    // this.user.card_code = "5295920";
    // this.user.identification_number = "99021006145";
    // this.verification_key = "8a23a5";
    // this.genuine_civ_code = true;
    // this.verified_identification = true;

    //this.verifyCode();
  }
};
</script>
<style>
</style>
